import VueI18n from 'vue-i18n';
import Vue from 'vue';
import all from '@/translations/i18n';

const dateTimeFormats = {
  en: {
    short: {
      year: 'numeric',
      month: 'long',
      day: '2-digit',
    },
    long: {
      year: 'numeric',
      month: 'long',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    },
  },
  it: {
    short: {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
    },
    long: {
      day: 'numeric',
      month: 'short',
      year: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    },
  },
};

Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: localStorage.getItem('language') || 'it',
  fallbackLocale: localStorage.getItem('language') || 'it',
  messages: {},
  dateTimeFormats
});

i18n.mergeLocaleMessage('it', all.it);
i18n.mergeLocaleMessage('en', all.en);

export default i18n;
